import { useState } from 'react';
import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const ProductImages = ({ images = [] }) => {
  const [index, setIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const imgs = images.length
    ? images
    : [{ image_url: process.env.REACT_APP_NOIMAGE }];

  const maxIndex = imgs.length - 1;

  const prev = () => setIndex((i) => Math.max(i - 1, 0));
  const next = () => setIndex((i) => Math.min(i + 1, maxIndex));

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: 500,
        mx: 'auto',
      }}
    >
      {/* メイン画像 */}
      <Box
        sx={{
          width: '100%',
          aspectRatio: '1 / 1',
          overflow: 'hidden',
          borderRadius: 1,
          position: 'relative',
        }}
      >
        <img
          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${imgs[index].image_url}`}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#fff' }}
        />

        {/* 左右ボタン（PCのみ） */}
        {!isMobile && (
          <>
            <IconButton
              onClick={prev}
              disabled={index === 0}
              sx={{
                position: 'absolute',
                top: '50%',
                left: 8,
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(0,0,0,0.3)',
                color: '#fff',
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.5)' },
              }}
            >
              <ChevronLeftIcon />
            </IconButton>

            <IconButton
              onClick={next}
              disabled={index === maxIndex}
              sx={{
                position: 'absolute',
                top: '50%',
                right: 8,
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(0,0,0,0.3)',
                color: '#fff',
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.5)' },
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          </>
        )}
      </Box>

      {/* サムネイル */}
      <Box
        sx={{
          mt: 1,
          display: 'flex',
          gap: 1,
          overflowX: 'auto',
          pb: 1,
        }}
      >
        {imgs.map((img, i) => (
          <Box
            key={img.image_url}
            onClick={() => setIndex(i)}
            sx={{
              width: 120,
              aspectRatio: '1 / 1',
              flexShrink: 0,
              border: i === index
                ? '2px solid #000'
                : '2px solid transparent',
              borderRadius: 1,
              overflow: 'hidden',
              cursor: 'pointer',
            }}
          >
            <img
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}${img.image_url}`}
              alt=""
              style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#fff' }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ProductImages;
